import { types } from '../types/types';

const initialState = {

	menus: [],
	menuPaths: [],
	menusFull:[],
	
	isLoadingMenuPaths : false,
	isReLoadingMenuFromUrl : false
};

export const menuReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.MENU_ADMINISTRATOR:
			return {
				...state,
				administrator: action.payload,
			};
		case types.MENU_GROUP_ROLE:
			return {
				...state,
				menus: action.payload,
			};

		case types.MENU_IS_LOADING_PATHS:
			return {
				...state,
				isLoadingMenuPaths: true,
			};

		case types.MENU_IS_RELOADING_FROM_URL:
			return {
				...state,
				isReLoadingMenuFromUrl: true,
			};

		case types.MENU_PATH_FOR_COMPARE:
			return {
				...state,
				menuPaths: action.payload,
				isLoadingMenuPaths: false,
				isReLoadingMenuFromUrl:false,
			};

		/*
	case types.MENU_PANEL:
		return {
			...state,
			panel: action.payload,
		};

	case types.MENU_TECHNICAL:
		return {
			...state,
			technical: action.payload,
		};

	case types.MENU_CLIENT:
		return {
			...state,
			client: action.payload,
		};
		*/

		case types.MENU_SELECT:
			return {
				...state,
				menu: action.payload,
			};

		case types.MENU_UPDATE:
			if (state.menusS.length > 0) {
				return {
					...state,
					menusS: state.menusS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
					menusP: state.menusP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
				};
			} else {
				return {
					...state,
					menusP: state.menusP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
				};
			}

		case types.MENU_DELETE:
			if (state.menusS.length > 0) {
				return {
					...state,
					menusS: state.menusS.filter((usr) => usr.id !== action.payload),
					menusP: state.menusP.filter((usr) => usr.id !== action.payload),
					menu: {},
				};
			} else {
				return {
					...state,
					menusP: state.menusP.filter((usr) => usr.id !== action.payload),
					menu: {},
				};
			}

		case types.MENU_START_LOADING:
			return {
				...state,
				menusFull: action.payload,
			};

		case types.MENU_START_LOADING_PAGINATED:
			return {
				...state,
				menusP: action.payload.menusP,
				totalItemsP: action.payload.totalItems,
				totalPagesP: action.payload.totalPages,
				currentPageP: action.payload.currentPage,
			};

		case types.MENU_START_SEARCH:
			return {
				...state,
				menusS: action.payload,
			};

		case types.MENU_START_SEARCH_PAGINATED:
			return {
				...state,
				menusS: action.payload.menusP,
				totalItemsS: action.payload.totalItems,
				totalPagesS: action.payload.totalPages,
				currentPageS: action.payload.currentPage,
			};

		case types.MENU_CLEAN_SEARCH_PAGINATED:
			return {
				...state,
				menusS: [],
			};

		case types.MENU_CLEAN:
			return {
				...state,
				menu: {},
			};

		case types.MENU_START_REGISTER:
			return {
				...state,
				menu: action.payload,
			};

		case types.MENU_SET_SEARCH_TEXT:
			return {
				...state,
				searchTextState: action.payload,
			};

		case types.USER_CLEAN_SEARCH_TEXT:
			return {
				...state,
				searchTextState: "",
			};

		default:
			return state;
	}
};
